import getBruggerAdminClientAddress from '@Infowijs-eng/component-library/modules/getBruggerAdminClientAddress'
import { getHoyClientForUserPermissions, isDevelopment, isStaging } from '@Infowijs-eng/component-library/modules'

export default function getRedirectUrlForCustomerProduct(
  productType: string,
  productName: string,
  userPermissions: string[] = [],
) {
  switch (productType) {
    case 'hoy':
      return getHoyClientForUserPermissions(productName, userPermissions)
    case 'brugger':
      return getBruggerAdminClientAddress(productName)
    case 'schoolwiki': {
      if (isDevelopment && process.env.INFOWIJS_CLIENT_SCHOOLWIKI) {
        return process.env.INFOWIJS_CLIENT_SCHOOLWIKI.toLowerCase().replace('[subdomain]', productName)
      }
      const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'
      const clientUriPart = isStaging ? '.staging' : ''
      return `https://${productName}${clientUriPart}.schoolwiki.${tld}/admin`
    }
    default:
      return null
  }
}
